module.exports = __webpack_public_path__ + "img/koehler_logo.d6e7b267.svg";